'use strict';

var EditStaticHostMapping = require('actionGroups/staticHostMapping/StaticHostMapping');

module.exports = {
  Model: EditStaticHostMapping,
};
